var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crop-view  fade-in-fwd crop-view-myProject-ht" },
    [
      _c("img", {
        ref: "imgRef",
        staticClass: "d-block mw-100 sr-only",
        style: _vm.getStyleObject,
        attrs: { alt: "", src: _vm.src }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }